
import { Component, Vue } from 'vue-property-decorator'
import { store } from '@common/store'
import { action } from '@common/store'
import jumpLogin from '@plat-components/utils2/_esm5/jumpLogin'
import { ProgressParams } from '@/types'
import Progress from '../Progress.vue'
import Dialog from '../Dialog.vue';
import { staticText } from '@common/config'
import logger from '@plat-components/utils2/_esm5/logger'
import { isElementInViewport, throttle, getElementByAttr } from '@common/utils'
import biliActEvents from '@bilibili/bili-act-events'
import BiliUser from '@bilibili/bili-user'

@Component({
  name: 'videoPage',
  components: {
    Progress,
    Dialog
  },
})
export default class VideoPage extends Vue {
    visible = false
    isBonusLogger = false
    isRankLogger = false
    ruleType = 'bonusPool'
    
    get userInfo() {
      return store.userInfo
    }

    get dataInfo() {
      return store.data
    }

    get text() {
      return store.data && store.data.state ? staticText[store.data.state] : staticText[0]
    }

    handleDialog() {
      this.visible = true
      this.ruleType = 'bonusPool'
    }

    get progressList() {
      const data = store.data
      if (!data.award_stages) return [] 
      const res: ProgressParams[] = []
      const len = data.award_stages.length
      let index = 0
      while (len > index) {
        const nodePercent = Number((100 / (len + 1) * (index + 1)).toFixed(2))
        res.push({
          nodePercent,
          playText: data.play_text[index],
          awardText: data.award_text[index].replace('瓜分', ''),
        })
        index++
      }
      return res
    }

    get percent() {
      console.log('store.data', store.data)
      if (!store.data.play) return 0
      let play = store.data.play
      // let play = 2100000000;
      const threshold = 2100000000
      const lowThreshold = 100000000 / 2;
      if (play > threshold) play = threshold;
      if (play <= lowThreshold) play = lowThreshold;

      const awardStages = [ 100000000, 500000000, 1000000000, 1500000000 ]
      const len = awardStages.length
      // const awardStages = store.data.award_stages
      // const play = 4000
      // const awardStages = [ 1000, 5000, 10000, 50000 ]
      // const len = awardStages.length
      const p = 100 / (len + 1) // 20 len:4
      let index = 0
      let res = 0
      if (play <= awardStages[0]) { // 25/
        return Number((p * (play / awardStages[0])).toFixed(2))
      }
      if (play >= awardStages[len-1]) {
        return Number((p * (len + (play - awardStages[len-1]) / awardStages[len-1])).toFixed(2))
      }
      while (index < len) {
        if (play >= awardStages[index] && play <= awardStages[index + 1]) {
          res = Number((p * (index + 1 + (play - awardStages[index]) / (awardStages[index + 1] - awardStages[index]))).toFixed(2))
        }
        index ++
      }
      return res
    }

    login() {
      jumpLogin()
    }

    mounted() {
      action.getUserInfo();
      action.getAwardData();
      BiliUser.watch((res: any) => {
        console.log(res, 'login watch')
        action.getUserInfo();
        action.getAwardData();
      })
      biliActEvents.on('OPEN_DIALOG', async () => {
        this.visible = true
        this.ruleType = 'rank'
      })
      window.onscroll = () => {
        const rankDom = getElementByAttr('section', 'data-fid', 'Mz96JnkJjqV') as HTMLDivElement
        // const videoDom = getElementByAttr('section', 'data-fid', 'MEV63Ti0ced') as HTMLDivElement
        const videoDom = getElementByAttr('section', 'data-fid', 'MPrvEUItgOA') as HTMLDivElement
        const rankDom2 = document.getElementById('daily')
        const videoDom2 = document.getElementById('bonus-pool')
        if (!this.isBonusLogger && isElementInViewport(videoDom, videoDom2, 150)) {
          console.log('曝光打点')
          this.isBonusLogger = true
          logger('bonus_process_show')
        }
        if (!this.isRankLogger && isElementInViewport(rankDom, rankDom2)) {
          console.log('排行榜曝光')
          this.isRankLogger = true
          logger('list_show')
        }
      }
      // var isTra = false
      // var interval = setInterval(() => {
      //   if (document.getElementById('webShare')) {
      //     const box = document.querySelector('#webShare .bili-share-pc') as HTMLDivElement
      //     box.style.background = '#282e3b'
      //     box.style.border = '1px solid #282e3b'
      //     const appID = document.getElementById('app') as HTMLDivElement
      //     const div = document.getElementById('webShare') as HTMLDivElement
      //     const target = document.getElementById('MXucRWXiAhN') as HTMLDivElement
      //     appID.insertBefore(div, target.nextSibling)
      //     clearInterval(interval)
      //   }
      // }, 1000)
    }
}
